module.exports = __webpack_public_path__ + "static/media/icon.phone.e3df8438.svg";